var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"data-testid":"download-button","small":"","text":"","color":"primary","loading":_vm.loadingBtn},on:{"click":function($event){return _vm.downloadFile(_vm.item.id)}}},[_vm._v(" "+_vm._s(_vm.item.file_name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }